import axios from "axios";

const configuredApiBase = process.env.REACT_APP_NOT_SECRET_CODE || "";

const headers = (token) => ({
  "Content-Type": "application/json",
  "X-Request-ID": "124",
  "X-Country-Code": "BD",
  "X-Client-Name": "POS",
  "X-Client-Version": "123",
  Authorization: "Bearer " + token,
});

const unwrapApiResponse = (res) => {
  const payload = res.data;

  if (payload && payload.success === false) {
    const error = new Error(payload.message || "Request failed.");
    error.response = { data: payload };
    throw error;
  }

  return payload;
};

export const getPosBootstrap = (token, params = {}) => {
  return axios
    .get(`${configuredApiBase}/pos/bootstrap`, {
      params,
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getPosReportSummary = (token, params = {}) => {
  return axios
    .get(`${configuredApiBase}/pos/reports/summary`, {
      params,
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getPosProducts = (token, params = {}) => {
  return axios
    .get(`${configuredApiBase}/pos/products`, {
      params,
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const getPosOtherOrders = (token, params = {}) => {
  return axios
    .get(`${configuredApiBase}/pos/orders/other`, {
      params,
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const submitPosOtherOrder = (token, id, body = {}) => {
  return axios
    .post(`${configuredApiBase}/pos/orders/other/${id}/submit`, body, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const createPosProduct = (token, body = {}) => {
  return axios
    .post(`${configuredApiBase}/pos/products`, body, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const updatePosProduct = (token, id, body = {}) => {
  return axios
    .put(`${configuredApiBase}/pos/products/${id}`, body, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const receivePosInventory = (token, body = {}) => {
  return axios
    .post(`${configuredApiBase}/pos/inventory/receive`, body, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};

export const syncPosSale = (token, body = {}) => {
  return axios
    .post(`${configuredApiBase}/pos/sales/sync`, body, {
      headers: headers(token),
    })
    .then(unwrapApiResponse);
};
